let Arr = {
    "Бухгалтер": {id: 1, code: 'ROLE_BUH', name: 'Бухгалтер'},
    "Менеджер": {id: 2, code: 'ROLE_MANAGER', name: 'Менеджер'},
    "Администратор": {id: 3, code: 'ROLE_ADMIN', name: 'Администратор'},
    "Пользователь": {id: 4, code: 'ROLE_USER', name: 'Пользователь'},
    "Водитель": {id: 5, code: 'ROLE_DRIVER', name: 'Водитель'},
    "Клиент": {id: 6, code: 'ROLE_CLIENT', name: 'Клиент'},
}

export default Arr
